import { gql } from '@apollo/client'

import { DICTIONARY_WORDS_FRAGMENT } from '../fragments'

const TRANSFER_DICTIONARY_WORD_TO_INGREDIENT_MUTATION = gql`
  mutation transferDictionaryWordToIngredient(
    $id: ID!
    $keyword: IngredientKeywordInput!
    $filters: DictionaryWordFiltersInput
    $page: Int
    $pageSize: Int
  ) {
    transferDictionaryWordToIngredient(
      id: $id
      keyword: $keyword
      filters: $filters
      page: $page
      pageSize: $pageSize
    ) {
      ...DictionaryWordsFragment
    }
  }
  ${DICTIONARY_WORDS_FRAGMENT}
`

export default TRANSFER_DICTIONARY_WORD_TO_INGREDIENT_MUTATION
